import { inOutDirectiveFactory } from 'vue-in-out/src/in-out-factory.js';


export const innerFocus = inOutDirectiveFactory({
    inEvent: 'focusin',
    outEvent: 'focusout',
    activeClass: 'focused',
});
